import {BaseContainerModel} from "../../../base-container.model";
import {
  bl_alg_cc_squad_hdr_RowClass,
  bl_alg_cc_squad_hdr_RowInterface,
  bl_alg_cc_squad_ext_RowClass
} from "../../../../dbschema";

export class SquadContainerModel extends BaseContainerModel {
  bl_alg_cc_squad_hdr: bl_alg_cc_squad_hdr_RowInterface = new bl_alg_cc_squad_hdr_RowClass();
  bl_alg_cc_squad_exts: bl_alg_cc_squad_ext_RowClass[] = [];
}
